module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_3009.0b10bfc4.png";